<template>
    <div class="field">
        <div class="select is-fullwidth">
            <select id="manager" v-model="query.manager">
                <option :value="null" hidden disabled>Select manager</option>
                <option v-for="manager in managers" :value="manager.id">
                    {{ manager.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    import apiUsers from '../../../api/apiUsers'
    export default {
        data() {
            return {
                managers: []
            }
        },
        computed: {
            query() {
                return this.$store.getters.getBidsQuery
            }
        },
        mounted() {
            apiUsers
                .managerListRequest()
                .then((response) => {
                    this.managers = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Bids/SearchInputs/InchargeSelect.vue